import {
  GET_REPAIR_ORDERS_REQUEST,
  GET_REPAIR_ORDERS_SUCCESS,
  GET_REPAIR_ORDERS_FAILURE,
  GET_REPAIR_ORDER_REQUEST,
  GET_REPAIR_ORDER_SUCCESS,
  GET_REPAIR_ORDER_FAILURE,
  CREATE_REPAIR_ORDER_REQUEST,
  CREATE_REPAIR_ORDER_SUCCESS,
  CREATE_REPAIR_ORDER_FAILURE,
  UPDATE_REPAIR_ORDER_REQUEST,
  UPDATE_REPAIR_ORDER_SUCCESS,
  UPDATE_REPAIR_ORDER_FAILURE,
  UPDATE_REPAIR_ORDER_STATUS_REQUEST,
  UPDATE_REPAIR_ORDER_STATUS_SUCCESS,
  UPDATE_REPAIR_ORDER_STATUS_FAILURE,
  ADD_REPAIR_ORDER_PAYMENT_REQUEST,
  ADD_REPAIR_ORDER_PAYMENT_SUCCESS,
  ADD_REPAIR_ORDER_PAYMENT_FAILURE,
  MARK_REPAIR_ORDER_DELIVERED_REQUEST,
  MARK_REPAIR_ORDER_DELIVERED_SUCCESS,
  MARK_REPAIR_ORDER_DELIVERED_FAILURE,
  GET_REPAIR_ORDER_PAYMENTS_REQUEST,
  GET_REPAIR_ORDER_PAYMENTS_SUCCESS,
  GET_REPAIR_ORDER_PAYMENTS_FAILURE,
  OUTSOURCE_REPAIR_ORDER_REQUEST,
  OUTSOURCE_REPAIR_ORDER_SUCCESS,
  OUTSOURCE_REPAIR_ORDER_FAILURE,
  MARK_REPAIR_ORDER_RECEIVED_REQUEST,
  MARK_REPAIR_ORDER_RECEIVED_SUCCESS,
  MARK_REPAIR_ORDER_RECEIVED_FAILURE,
  ADD_GOLDSMITH_PAYMENT_REQUEST,
  ADD_GOLDSMITH_PAYMENT_SUCCESS,
  ADD_GOLDSMITH_PAYMENT_FAILURE,
  GET_OUTSOURCE_TIMELINE_REQUEST,
  GET_OUTSOURCE_TIMELINE_SUCCESS,
  GET_OUTSOURCE_TIMELINE_FAILURE,
} from '../types';

const initialState = {
  repairOrders: [],
  currentRepairOrder: null,
  repairOrderPayments: {
    payments: [],
    paymentModeTotals: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
    }
  },
  outsourceTimeline: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  loading: false,
  error: null,
  success: null,
};

const repairOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get repair orders
    case GET_REPAIR_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_REPAIR_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        repairOrders: action.payload.data.repairOrders || [],
        pagination: action.payload.data.pagination || state.pagination,
      };

    case GET_REPAIR_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get single repair order
    case GET_REPAIR_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentRepairOrder: null,
      };

    case GET_REPAIR_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        currentRepairOrder: action.payload.data,
      };

    case GET_REPAIR_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentRepairOrder: null,
      };

    // Create repair order
    case CREATE_REPAIR_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case CREATE_REPAIR_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message || 'Repair order created successfully',
        repairOrders: [action.payload.data, ...state.repairOrders],
      };

    case CREATE_REPAIR_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Update repair order
    case UPDATE_REPAIR_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case UPDATE_REPAIR_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message || 'Repair order updated successfully',
        repairOrders: state.repairOrders.map(order =>
          order.id === action.payload.data.id ? action.payload.data : order
        ),
        currentRepairOrder: state.currentRepairOrder?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentRepairOrder,
      };

    case UPDATE_REPAIR_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Update repair order status
    case UPDATE_REPAIR_ORDER_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case UPDATE_REPAIR_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message || 'Repair order status updated successfully',
        repairOrders: state.repairOrders.map(order =>
          order.id === action.payload.data.id ? action.payload.data : order
        ),
        currentRepairOrder: state.currentRepairOrder?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentRepairOrder,
      };

    case UPDATE_REPAIR_ORDER_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Add repair order payment
    case ADD_REPAIR_ORDER_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case ADD_REPAIR_ORDER_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message || 'Payment added successfully',
        currentRepairOrder: state.currentRepairOrder ? {
          ...state.currentRepairOrder,
          payments: [...(state.currentRepairOrder.payments || []), action.payload.data]
        } : null,
      };

    case ADD_REPAIR_ORDER_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Mark repair order delivered
    case MARK_REPAIR_ORDER_DELIVERED_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case MARK_REPAIR_ORDER_DELIVERED_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message || 'Repair order marked as delivered',
        repairOrders: state.repairOrders.map(order =>
          order.id === parseInt(action.payload.data.repair_order_id || action.payload.data.id)
            ? { ...order, status: 'delivered' }
            : order
        ),
        currentRepairOrder: state.currentRepairOrder?.id === parseInt(action.payload.data.repair_order_id || action.payload.data.id)
          ? { ...state.currentRepairOrder, status: 'delivered' }
          : state.currentRepairOrder,
      };

    case MARK_REPAIR_ORDER_DELIVERED_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Get repair order payments
    case GET_REPAIR_ORDER_PAYMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_REPAIR_ORDER_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        repairOrderPayments: {
          payments: action.payload.data?.payments || action.payload.payments || [],
          paymentModeTotals: action.payload.data?.paymentModeTotals || action.payload.paymentModeTotals || [],
          pagination: action.payload.pagination || action.payload.data?.pagination || state.repairOrderPayments.pagination,
        },
      };

    case GET_REPAIR_ORDER_PAYMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Outsource repair order
    case OUTSOURCE_REPAIR_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case OUTSOURCE_REPAIR_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message || 'Repair order outsourced successfully',
        repairOrders: state.repairOrders.map(order =>
          order.id === action.payload.data.id ? action.payload.data : order
        ),
        currentRepairOrder: state.currentRepairOrder?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentRepairOrder,
      };

    case OUTSOURCE_REPAIR_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Mark repair order received
    case MARK_REPAIR_ORDER_RECEIVED_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case MARK_REPAIR_ORDER_RECEIVED_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message || 'Repair order marked as received',
        repairOrders: state.repairOrders.map(order =>
          order.id === action.payload.data.id ? action.payload.data : order
        ),
        currentRepairOrder: state.currentRepairOrder?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentRepairOrder,
      };

    case MARK_REPAIR_ORDER_RECEIVED_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Add goldsmith payment
    case ADD_GOLDSMITH_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case ADD_GOLDSMITH_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message || 'Payment added successfully',
      };

    case ADD_GOLDSMITH_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Get outsource timeline
    case GET_OUTSOURCE_TIMELINE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_OUTSOURCE_TIMELINE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        outsourceTimeline: action.payload.data || [],
      };

    case GET_OUTSOURCE_TIMELINE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default repairOrderReducer;

